import { ConsumableQuantityEstimationThemeSizeConfig } from './types';

const medium: ConsumableQuantityEstimationThemeSizeConfig = {
  consumableQuantityEstimation: {},
};

export default medium;
